var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{ref:`vimeo-video-${_vm.id}`,staticClass:"video-tracking",attrs:{"id":_vm.id,"width":"100%","height":"450","src":`${_vm.urlVideo}`,"frameborder":"0","allow":"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }